exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.Notice .van-notice-bar{\r\n  background:#f8f8f8 !important;\r\n  padding:0 !important;\r\n  height:41px !important;\r\n  line-height: 20px !important;\n}\r\n", ""]);

// exports
